import { ReactNode } from 'react';

import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { ActionEventInterceptor } from '@dreryk/react-components';

import { dispatchShowPrescriptionVisitDataModalEvent } from '../../../../visit/prescriptionVisitData/PrescriptionVisitDataModal.event';

type PrescriptionVisitDataRequiredActionInterceptorProps = {
   readonly visitDiagnoses: VisitDiagnosis[];
   readonly children: ReactNode;
};

const hasMainDiagnosis = (diagnoses: VisitDiagnosis[]): boolean => {
   return diagnoses.filter((diagnosis) => diagnosis.main).length === 1;
};

export const PrescriptionVisitDataRequiredActionInterceptor = (
   props: PrescriptionVisitDataRequiredActionInterceptorProps
): JSX.Element => {
   const handleAction = async (): Promise<void> => {
      if (!hasMainDiagnosis(props.visitDiagnoses)) {
         dispatchShowPrescriptionVisitDataModalEvent({ validateOnOpen: true });
         return Promise.reject(new Error());
      }

      return Promise.resolve();
   };

   return <ActionEventInterceptor action={handleAction}>{props.children}</ActionEventInterceptor>;
};
